<dx-data-grid [(dataSource)]="generatedUnits"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [allowColumnResizing]="true">
  <dxo-editing mode="cell"
               [allowUpdating]="false"
               [allowDeleting]="false"
               [allowAdding]="false"
               [useIcons]="true">
  </dxo-editing>

  <dxi-column dataField="unitDescription" caption="{{ 'EinheitenCodeBeschreibung' | translate }}"></dxi-column>
  <dxi-column dataField="unit" caption="{{ 'EinheitenCode' | translate }}"></dxi-column>
  <dxi-column dataField="contentQuanitity" caption="{{ 'Menge Einheitencode' | translate }}"></dxi-column>
</dx-data-grid>

<dx-data-grid (onToolbarPreparing)="onGridToolbarPreparing($event)"
              [(dataSource)]="product.packings"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [allowColumnResizing]="true"
              noDataText="{{ 'keine Einheiten gepflegt' | translate }}"
              [showBorders]="true"
              (onContentReady)="onContentReady()"
              (onRowRemoved)="delete($event)">

  <dxo-editing mode="cell"
               [allowUpdating]="true"
               [allowDeleting]="true"
               [allowAdding]="false"
               [useIcons]="true">
    <dxo-texts confirmDeleteMessage="{{ 'Wirklich löschen' | translate }}" confirmDeleteTitle="{{ 'EinheitenCode' | translate }}"></dxo-texts>
  </dxo-editing>

  <div *dxTemplate="let toolbaritem of 'newSupplierUnitButtonTemplate'">
    <dx-button *ngIf="canView('AddSupplierUnit')" stylingMode="text" [disabled]="updateLock" type="default" text="{{ 'Neuer Einheitencode' | translate }}" (onClick)="add()"></dx-button>
  </div>

  <div *dxTemplate="let toolbaritem of 'generateMissingCodesButtonTemplate'">
    <dx-button *ngIf="canView('GenerateMissingUnits') && modelService.loginService.hasAddonGevis" stylingMode="text"
               [disabled]="updateLock" type="default" text="{{ 'Fehlende Codes Generieren' | translate }}" (onClick)="generateMissingCodes()"></dx-button>
  </div>


  <dxo-state-storing [enabled]="false" type="localStorage" storageKey="SupplierPackingUnits"></dxo-state-storing>

  <dxi-column dataField="order" dataType="number" caption="{{ 'Order' | translate }}" [allowEditing]="false" [sortIndex]="0"></dxi-column>


  <dxi-column dataField="unit" caption="{{ 'EinheitenCode' | translate }}" cellTemplate="unitTemplate" editCellTemplate="unitTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'unitTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing.data.unit?.length > 0"
                       [suppressToolTip]="true"
                       [suppressLabel]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'EinheitenCode' | translate }}"
                       [field]="templateService.fieldNames.packingUnit"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-text-box [(value)]="packing.data.unit"
                       [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingUnit,packing.data.order.toString()) || readOnly(templateService.fieldNames.packingUnit)"
                       [showClearButton]="showClearButton('SUPPLIER_ID', packing.data.order.toString())"
                       (onValueChanged)="update($event, templateService.fieldNames.packingUnit, packing.data.order.toString())">
          </dx-text-box>
        </div>
      </np-inputControl>
    </div>
  </div>


  <dxi-column caption="{{ 'GevisMapping' | translate}}" cellTemplate="gevisMappingTemplate" editCellTemplate="gevisMappingTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'gevisMappingTemplate'">
    <dx-text-box [value]="getGevisMappedCode(packing.data.unit)" [readOnly]="true">
    </dx-text-box>
  </div>


  <dxi-column dataField="contentQuantity" caption="{{ 'Menge Basiseinheit' | translate }}" cellTemplate="contentQuantityTemplate" editCellTemplate="contentQuantityTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'contentQuantityTemplate'">
    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing.data.contentQuantity != null"
                       [suppressToolTip]="true"
                       [suppressLabel]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'EinheitenCode' | translate }}"
                       [field]="templateService.fieldNames.packingContentQuantity"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-number-box [(value)]="packing.data.contentQuantity"
                         [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingContentQuantity,packing.data.order.toString()) || readOnly(templateService.fieldNames.packingContentQuantity)"
                         [showClearButton]="showClearButton(templateService.fieldNames.packingContentQuantity, packing.data.order.toString())"
                         (onValueChanged)="update($event, templateService.fieldNames.packingContentQuantity, packing.data.order.toString())">
          </dx-number-box>
        </div>
      </np-inputControl>
    </div>
  </div>

  <dxi-column dataField="quantityMin" caption="{{ 'Mindestmenge' | translate }}" cellTemplate="quantityMinTemplate" editCellTemplate="quantityMinTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'quantityMinTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing.data.quantityMin != null"
                       [suppressToolTip]="true"
                       [suppressLabel]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Mindestmenge' | translate }}"
                       [field]="templateService.fieldNames.packingQuantityMin"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-number-box [(value)]="packing.data.quantityMin"
                         [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingQuantityMin,packing.data.order.toString()) || readOnly(templateService.fieldNames.packingQuantityMin)"
                         [showClearButton]="showClearButton(templateService.fieldNames.packingQuantityMin, packing.data.order.toString())"
                         (onValueChanged)="update($event, templateService.fieldNames.packingQuantityMin, packing.data.order.toString())">
          </dx-number-box>
        </div>
      </np-inputControl>
    </div>
  </div>

  <dxi-column dataField="quantityMax" caption="{{ 'Höchtsmenge' | translate }}" cellTemplate="quantityMaxTemplate" editCellTemplate="quantityMaxTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'quantityMaxTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing.data.quantityMax != null"
                       [suppressToolTip]="true"
                       [suppressLabel]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Mindestmenge' | translate }}"
                       [field]="templateService.fieldNames.packingQuantityMax"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-number-box [(value)]="packing.data.quantityMax"
                         [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingQuantityMax, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingQuantityMax)"
                         [showClearButton]="showClearButton(templateService.fieldNames.packingQuantityMax, packing.data.order.toString())"
                         (onValueChanged)="update($event, templateService.fieldNames.packingQuantityMax, packing.data.order.toString())">
          </dx-number-box>
        </div>
      </np-inputControl>
    </div>
  </div>

</dx-data-grid>
